<template>
  <div>
    <div class="profile-details">
      <div class="profile-user__info">
        <div class="profile-user__name">
          {{ profile.name }}, {{ profile.age }}
          <div v-if="profile.is_online" class="dot-online"></div>
        </div>

        <div class="profile-user__loc">
          {{ profile.regular_address }}
        </div>
      </div>
      <div class="row profile-user__row-veryfication p-un mt-1" v-if="profile.verified_at">
        <p class="verification-desc verification-desc--positive pl-3">{{ trans.get('profile:show.profile_verified_by_photo') }}</p>
      </div>
      <div class="profile-user__about">
        <section v-if="profile.description">
          <p style="white-space: pre-line">{{ profile.description }}</p>
        </section>
      </div>

      <div class="profile-user__statuses" v-if="profile.attributes.has_any">
        <div class="box-status">
          <div class="box-attributes" v-if="profile.attributes.relationship">
            <div class="box-attributes__attr">
              <span>{{ trans.get('profile:show.info.relationship') }} </span>
            </div>
            <div class="box-attributes__set"> {{ profile.attributes.relationship_text }}</div>
          </div>
          <div class="box-attributes" v-if="profile.attributes.has_children">
            <div class="box-attributes__attr">
              <span>{{ trans.get('profile:show.info.children') }} </span></div>
            <div class="box-attributes__set">{{ profile.attributes.has_children_text }}</div>
          </div>
          <div class="box-attributes" v-if="profile.attributes.living">
            <div class="box-attributes__attr">
              <span>{{ trans.get('profile:show.info.living') }} </span></div>
            <div class="box-attributes__set">{{ profile.attributes.living_text }}</div>
          </div>
          <div class="box-attributes" v-if="profile.attributes.smoker">
            <div class="box-attributes__attr">
              <span>{{ trans.get('profile:show.info.smoker') }}</span></div>
            <div class="box-attributes__set">{{ profile.attributes.smoker_text }}</div>
          </div>
        </div>
      </div>
      <div class="profile-user__report">
        <ReportModalButton :profileId="profile.id"></ReportModalButton>
      </div>
    </div>

    <div class="profile-details__space"></div>
  </div>
</template>

<script>

import ReportModalButton from '../../modules/ReportModalButton';
import MatchGameMixin from '../../../../js/front/components/MatchGame/MatchGameMixin';

export default {
  name: 'ProfileDetails',
  components: { ReportModalButton },
  mixins: [MatchGameMixin],
  props: {
    profile: Object,
  },
  data() {
    return {};
  },
  methods: {},
  mounted() {
  }
};
</script>


